import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Grid,
  Hidden,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Helmet } from 'react-helmet';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';

import heroImg from '../../static/img/membership_page/memb_page_hero.png';
import stockImg from '../../static/img/membership_page/mind_body_fitness_class.webp';
import dancingChart from '../../static/img/membership_page/memb_page_dancing_chart.png';
import athleteChart from '../../static/img/membership_page/memb_page_athlete_chart.png';
import livelihoodChart from '../../static/img/membership_page/memb_page_livelihood_chart.png';

import quoteImg1 from '../../static/img/membership_page/profile_image_2_mind_body_fitness.webp';
import quoteImg2 from '../../static/img/membership_page/profile_image_3_mind_body_fitness.webp';
import quoteImg3 from '../../static/img/membership_page/profile_image_mind_body_fitness.webp';

import PDF from '../../static/docs/NiaMembershipBenefits.pdf';

// To change the amount of benefits each type of membership recieves,
// search for lastBenefitID and change the number up or down.
// They are sequential.

const content = {
  chart: [
    // 0
    {
      description: '12 Months Unlimited Nia® On Demand Subscription',
      tooltip: '',
      price: '$144',
    },
    // 1
    {
      description: 'Monthly Member Calls with Debbie Rosas + Training Faculty',
      tooltip: '',
      price: '$300',
    },
    // 2
    {
      description: '12 Month Access to Nia Online Training Live Session Replay *',
      tooltip: 'Applicable for online trainings',
      price: '$199',
    },
    // 3
    {
      description: 'Membership Lifetime Access To Online Portals for All Completed Nia Trainings',
      tooltip: '',
      price: '$399',
    },
    // 4
    {
      description: '$100 Credit Towards Your Next Belt',
      tooltip: 'When registered within 12 months of graduation',
      price: '$100',
    },
    // 5 (last one that DTL gets)
    {
      description: '$900 Off Any Full Belt Retake + Discounts on session audits and specialty training retakes',
      tooltip: '',
      price: '$900',
    },
    // 6
    {
      description: 'Access to Dozens of Nia Routines + Teacher Exclusive Content on Nia® On Demand',
      tooltip: '',
      price: '$499',
    },
    // 7
    {
      description: '3 NEW Nia Routines Per Year (including video, music, teacher feature tutorials, bars and choreography notes)',
      tooltip: '',
      price: '$300',
    },
    // 8
    {
      description: '60% Discount on NiaSounds Digital Downloads',
      tooltip: '',
      price: '--',
    },
    // 9
    {
      description: 'Limited Nia Teaching License (up to 3 classes per month)',
      tooltip: '',
      price: '$75',
    },
    // 10
    {
      description: 'Full Nia Teaching License',
      tooltip: '',
      price: '$150',
    },
    // 11 (last one that SA gets)
    {
      description: 'Nia Business + Marketing + Brand Guides',
      tooltip: '',
      price: '$99',
    },
    // 12
    {
      description: 'Nia Marketing Social Media Templates, Logos, Image Library *',
      tooltip: '',
      price: '$299',
    },
    // 13
    {
      description: 'Library of On-Demand Business + Marketing Coaching Calls',
      tooltip: '',
      price: '$500',
    },
  ],
  discover: 'DISCOVER YOUR NIA COMMUNITY !',
  description: 'The Nia membership is for every training graduate, with choices for the passionate body and life student, the prospective Nia teacher and the Nia teaching professional. Joining Nia membership connects you to a global movement of peers who, like you, are living the magic of Nia in body and life.',
  dancing: {
    color: 'rgb(237,64,63)',
    description: 'FOR THE PASSIONATE + COMMITTED NIA GRADUATE',
    includes: [
      'Nia® On Demand Subscription',
      'Monthly Member Calls + Events',
      'Full Access to Online Learning Portal',
      'Members-Only Discounts + Events',
    ],
    imgCard: dancingChart,
    imgChart: dancingChart,
    lastBenefitID: 5,
    naID: null,
    annualValue: '$2,042',
    annualInvestment: '$339',
    monthlyInvestment: '$29',
  },
  athlete: {
    color: 'rgb(129,150,229)',
    description: 'FOR GRADUATES WANTING TO LEARN + PRACTICE TEACHING SKILL',
    includes: [
      'All of Dancing Through Life  Membership +',
      'Nia Teaching Resources + Support',
      'Nia Routines + Music',
      'Limited Nia Teaching License (up to 3 classes per month)',
    ],
    imgCard: athleteChart,
    imgChart: athleteChart,
    lastBenefitID: 9,
    naID: null,
    annualValue: '$2,916',
    annualInvestment: '$399',
    monthlyInvestment: '$34',
  },
  livelihood: {
    color: 'rgb(175,189,71)',
    description: 'FOR CURRENT + ASPIRING NIA TEACHING PROFESSIONALS',
    includes: [
      'All of Sacred Athlete + Dancing Through Life Memberships +',
      'Full Nia Teaching License (4+ classes/month)',
      'Ability to List Classes + Profile on NiaNow.com',
      'Nia Logo, Images + Templates to Use in Marketing',
      'Resources, Education and Support to Grow Your Nia Business',
    ],
    imgCard: livelihoodChart,
    imgChart: livelihoodChart,
    lastBenefitID: 15,
    naID: 9,
    annualValue: '$3,889',
    annualInvestment: '$449',
    monthlyInvestment: '$39',
  },
  quote1: {
    img: quoteImg1,
    quote: 'I love the essence of Nia. The freedom to be in the moment listening to and loving your body. The freedom to give thanks and move your body your way. I love the connection and the sense of community of Nia',
    attribution: 'Teresa Simmons, Nia Blue Belt, US',
  },
  quote2: {
    img: quoteImg3,
    quote: '13+ years into the practice, Nia continues to support an enjoyable, soul-friendly everyday that honors all aspects of being human: body, mind, emotions, spirit. It\'s a workout, a community builder, a possibility to create livelihood in ways I could not imagine - and yet, hoped for. It\'s sweat, silliness, and serenity in the same package.',
    attribution: 'Minna Aalto, Nia Black Belt, Finland',
  },
  quote3: {
    img: quoteImg2,
    quote: 'I love the feeling of true connection... There is immense mutual respect and openness in communication. As a teacher the website is incredibly user friendly and accessible. Makes me feel very much a valued member.',
    attribution: 'Natalie Ermer, Nia Blue Belt, South Australia',
  },
};

// ##########QUOTE CARD#####################

const quoteStyles = theme => ({
  quoteContainer: {
    height: '100%',
  },
  quoteImg: {
    width: '95%',
    padding: theme.spacing(2),
  },
  quote: {
    letterSpacing: '1px',
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  quoteAuthor: {
    textAlign: 'right',
    fontSize: '.65em',
  },
});

let QuoteCard = ({ classes, quote }) => (
  <div className={classes.quoteContainer}>
    <img className={classes.quoteImg} src={quote.img} alt={quote.alt} />
    <Typography variant="body1" className={classes.quote}><em>{quote.quote}</em></Typography>
    <Typography variant="body2" className={classes.quoteAuthor}>{'-' + quote.attribution}</Typography>
  </div>
);

QuoteCard = withStyles(quoteStyles)(QuoteCard);

QuoteCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  // classes: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  quote: PropTypes.object.isRequired,
};


// ########## MEMBERSHIP CARD#####################

const membershipStyle = theme => ({
  membershipCardContainer: {
    
  },
  membershipCardImg: {
    
  },
  membershipCardDescription: {
    
  },
  dancing: {
    color: content.dancing.color,
  },
  dancingInclude: {
    marginTop: '5%',
    marginBottom: '5%',
    width: '40%',
    borderBottom: `1px solid ${content.dancing.color}`,
  },
  athlete: {
    color: content.athlete.color,
  },
  athleteInclude: {
    marginTop: '5%',
    marginBottom: '5%',
    width: '40%',
    borderBottom: `1px solid ${content.athlete.color}`,
  },
  livelihood: {
    color: content.livelihood.color,
  },
  livelihoodInclude: {
    marginTop: '5%',
    marginBottom: '5%',
    width: '40%',
    borderBottom: `1px solid ${content.livelihood.color}`,
  },
});

let MembershipCard = ({ classes, type }) => {
  let includesColor;
  let color;
  if (type.color === content.livelihood.color) {
    includesColor = classes.livelihoodInclude;
    color = classes.livelihood;
  } else if (type.color === content.athlete.color) {
    includesColor = classes.athleteInclude;
    color = classes.athlete;
  } else {
    includesColor = classes.dancingInclude;
    color = classes.dancing;
  }
  return (
    <div className={classes.membershipCardContainer}>
      <img className={classes.membershipCardImg} src={type.imgCard} alt={type.imgCardAlt} />
      <Typography variant="body2" className={color}>{type.description}</Typography>
      <Typography className={includesColor}>INCLUDES</Typography>
      <List className={classes.list}>
        {type.includes.map(thing => (
          <ListItem className={classes.listItem} key={thing}>
            <ListItemIcon className={color}><Typography>✓</Typography></ListItemIcon>
            <ListItemText key={thing}>{thing}</ListItemText>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

MembershipCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  type: PropTypes.object.isRequired,
};

MembershipCard = withStyles(membershipStyle)(MembershipCard);


// ##########MEMBERSHIP CHART#####################

const membershipChartStyles = theme => ({
  title: {
    textAlign: 'center',
    paddingTop: '10%',
    paddingBottom: '10%',
  },
  table: {
    borderCollapse: 'collapse',
  },
  headerImg: {

  },
  oddRow: {
    backgroundColor: 'none',
  },
  evenRow: {
    backgroundColor: 'rgb(238,236,232)',
  },
  center: {
    textAlign: 'center',
  },
  description: {
    padding: '10px',
  },
  livelihood: {
    color: content.livelihood.color,
    textAlign: 'center',
  },
  athlete: {
    color: content.athlete.color,
    textAlign: 'center',
  },
  dancing: {
    color: content.dancing.color,
    textAlign: 'center',
  },
  livelihoodBox: {
    backgroundColor: content.livelihood.color,
    textAlign: 'center',
    border: '2px solid white',
  },
  athleteBox: {
    backgroundColor: content.athlete.color,
    textAlign: 'center',
    border: '2px solid white',
  },
  dancingBox: {
    backgroundColor: content.dancing.color,
    textAlign: 'center',
    border: '2px solid white',
  },
  livelihoodButton: {
    color: content.livelihood.color,
    textAlign: 'center',
    border: `2px solid ${content.livelihood.color}`,
    fontSize: '.7rem',
  },
  athleteButton: {
    color: content.athlete.color,
    textAlign: 'center',
    border: `2px solid ${content.athlete.color}`,
    fontSize: '.7rem',
  },
  dancingButton: {
    color: content.dancing.color,
    textAlign: 'center',
    border: `2px solid ${content.dancing.color}`,
    fontSize: '.7rem',
  },
  white: {
    color: 'white',
  },
  strikeThrough: {
    textDecoration: 'line-through',
  },
  right: {
    textAlign: 'right',
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  centerMargin: {
    textAlign: 'center',
  },
  sectionSubHeader: {
    textAlign: 'center',
    fontSize: '12px',
    marginBottom: theme.spacing(3),
  },
});

function whatToDraw(index, type) {
  return {
    draw: index <= type.lastBenefitID,
    symbol: type.naID === index ? 'n/a' : '\u2B24',
  };
}

//  TODO: TOOLTIP

function createDataRow(className, center, index, description, descriptionClass, value, dancing, dancingClass, athlete, athleteClass, livelihood, livelihoodClass, tooltip) {
  const { draw: dancingBool, symbol: dancingShape } = whatToDraw(index, dancing);
  const { draw: athleteBool, symbol: athleteShape } = whatToDraw(index, athlete);
  const { draw: livelihoodBool, symbol: livelihoodShape } = whatToDraw(index, livelihood);
  return (
    <tr className={className} key={description}>
      {tooltip
        ? <Tooltip title={tooltip} placement="right"><td className={descriptionClass}><Typography color="textSecondary" variant="body1">{description}</Typography></td></Tooltip>
        : <td className={descriptionClass}><Typography color="textSecondary" variant="body1">{description}</Typography></td>
      }
      <td className={center}><Typography color="textPrimary" variant="body1">{value}</Typography></td>
      <td className={dancingClass}>{dancingBool && dancingShape}</td>
      <td className={athleteClass}>{athleteBool && athleteShape}</td>
      <td className={livelihoodClass}>{livelihoodBool && livelihoodShape === 'n/a' ? <strong>{livelihoodShape}</strong> : livelihoodShape }</td>
    </tr>
  );
}

const ChartHeader = ({ classes }) => (
  <tr>
    <th>{' '}</th>
    <th><Typography color="textSecondary">INDIVIDUAL BENEFIT VALUE</Typography></th>
    <th>
      <img className={classes.headerImg} src={dancingChart} alt={content.dancing.chartAlt} />
    </th>
    <th>
      <img className={classes.headerImg} src={athleteChart} alt={content.athlete.chartAlt} />
    </th>
    <th>
      {/* // eslint-disable-next-line max-len */}
      <img className={classes.headerImg} src={livelihoodChart} alt={content.livelihood.chartAlt} />
    </th>
  </tr>
);

ChartHeader.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
};

const ChartBottom = ({
  white,
  center,
  centerMargin,
  right,
  strikethrough,
  dancing,
  dancingButton,
  dancingBox,
  athlete,
  athleteButton,
  athleteBox,
  livelihood,
  livelihoodButton,
  livelihoodBox
}) => (
  <Fragment>
    {/* // annual membership value */}
    <tr>
      <td colSpan="2" className={right}>
        <Typography color="textPrimary" variant="body1">
          <strong>ANNUAL MEMBERSHIP VALUE: </strong>
        </Typography>
      </td>
      <td className={center}>
        <Typography className={strikethrough} color="textPrimary" variant="body1">
          { dancing.annualValue }
        </Typography>
      </td>
      <td className={center}>
        <Typography className={strikethrough} color="textPrimary" variant="body1">
          { athlete.annualValue }
        </Typography>
      </td>
      <td className={center}>
        <Typography className={strikethrough} color="textPrimary" variant="body1">
          { livelihood.annualValue }
        </Typography>
      </td>
    </tr>
    {/* // annual investment */}
    <tr>
      <td colSpan="2" className={right}>
        <Typography color="textPrimary" variant="body1">
          <strong>ANNUAL INVESTMENT: </strong>
        </Typography>
        <Typography color="textPrimary" variant="body2">
          (PREPAID)
        </Typography>
      </td>
      <td className={dancingBox}>
        <Typography className={white} variant="body1">
          <strong>{ `${dancing.annualInvestment}/yr` }</strong>
        </Typography>
      </td>
      <td className={athleteBox}>
        <Typography className={white} variant="body1">
          <strong>{ `${athlete.annualInvestment}/yr` }</strong>
        </Typography>
      </td>
      <td className={livelihoodBox}>
        <Typography className={white} variant="body1">
          <strong>{ `${livelihood.annualInvestment}/yr` }</strong>
        </Typography>
      </td>
    </tr>
    {/* MONTHLY INVESTMENT */}
    <tr>
      <td colSpan="2" className={right}>
        <Typography color="textPrimary" variant="body1">
          <strong>MONTHLY INVESTMENT: </strong>
        </Typography>
        <Typography color="textPrimary" variant="body2">
          (PAYMENT PLAN)
        </Typography>
      </td>
      <td className={dancingBox}>
        <Typography className={white} variant="body1">
          <strong>{ `${dancing.monthlyInvestment}/mo` }</strong>
        </Typography>
      </td>
      <td className={athleteBox}>
        <Typography className={white} variant="body1">
          <strong>{ `${athlete.monthlyInvestment}/mo` }</strong>
        </Typography>
      </td>
      <td className={livelihoodBox}>
        <Typography className={white} variant="body1">
          <strong>{ `${livelihood.monthlyInvestment}/mo` }</strong>
        </Typography>
      </td>
    </tr>
    <tr>
      <td colSpan="2">{' '}</td>
      <td className={centerMargin}>
        <Button className={dancingButton} href="/account/membership" variant="outlined">SIGN UP NOW</Button>
      </td>
      <td className={centerMargin}>
        <Button className={athleteButton} href="/account/membership" variant="outlined">SIGN UP NOW</Button>
      </td>
      <td className={centerMargin}>
        <Button className={livelihoodButton} href="/account/membership" variant="outlined">SIGN UP NOW</Button>
      </td>
    </tr>
  </Fragment>
);

ChartBottom.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  right: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  strikethrough: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dancing: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  athlete: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  livelihood: PropTypes.object.isRequired,
};

let MembershipChart = ({ classes, chart, dancing, athlete, livelihood, sectionHeader }) => (
  <div>
    <Typography className={sectionHeader} color="textSecondary" variant="h2">NIA MEMBER BENEFITS</Typography>
    <Typography className={classes.sectionSubHeader} color="textSecondary" variant="h6">(Membership benefits subject to change)</Typography>
    <table className={classes.table}>
      <thead>
        <ChartHeader classes={classes} />
      </thead>
      <tbody>
        {/* // eslint-disable-next-line max-len */}
        {chart.map((row, index) => ((index + 1) % 2 === 0
          ? createDataRow(classes.oddRow, classes.center, index, row.description, classes.description, row.price, dancing, classes.dancing, athlete, classes.athlete, livelihood, classes.livelihood, row.tooltip)
          : createDataRow(classes.evenRow, classes.center, index, row.description, classes.description, row.price, dancing, classes.dancing, athlete, classes.athlete, livelihood, classes.livelihood, row.tooltip)))}
        <ChartBottom
          center={classes.center}
          centerMargin={classes.centerMargin}
          right={classes.right}
          strikethrough={classes.strikeThrough}
          dancing={content.dancing}
          dancingButton={classes.dancingButton}
          dancingBox={classes.dancingBox}
          athlete={content.athlete}
          athleteButton={classes.athleteButton}
          athleteBox={classes.athleteBox}
          livelihood={content.livelihood}
          livelihoodButton={classes.livelihoodButton}
          livelihoodBox={classes.livelihoodBox}
          white={classes.white}
        />
      </tbody>
    </table>
  </div>
);
MembershipChart.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  chart: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dancing: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  athlete: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  livelihood: PropTypes.object.isRequired,
};

MembershipChart = withStyles(membershipChartStyles)(MembershipChart);

function MobileMembershipChart({ inputClass, inputClass2 }) {
  return (
    <div className={inputClass}>
      <Typography color="textPrimary" variant="body1"><em>Download a detailed chart comparing all Nia Membership Tiers.</em></Typography>
      <Button className={inputClass2} color="secondary" variant="outlined" href={PDF} target="_blank">All Membership Tiers (PDF)</Button>
      <Button className={inputClass2} color="secondary" variant="contained" href="/account/membership">Purchase Membership</Button>
    </div>
  );
}

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'white',
  },
  buttonSectionHeader: {
    marginBottom: theme.spacing(2),
    fontSize: '1em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  costLabel: {
    display: 'inline',
    textTransform: 'uppercase',
  },
  discoverButtonContainer: {
    height: '100%',
  },
  discoverButton: {
    margin: theme.spacing(),
  },
  discoverSectionText: {
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  hero: {
    height: 'auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: theme.spacing(4),
  },
  header: {
    position: 'relative',
    top: '10px',
    width: '100%',
    textAlign: 'left',
    textTransform: 'uppercase',
    [theme.breakpoints.down(800)]: {
      top: '7px',
      fontSize: '2.5em',
    },
  },
  heroImg: {
    height: 'auto',
    width: '100%',
  },
  keyWordContainer: {
    margin: 'auto',
  },
  keyWord: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    fontSize: '2em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  section: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  stockImg: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    // transform: 'translateX(-50%)',
  },
  sectionText: {
    paddingBottom: theme.spacing(2),
  },
  sectionHeader: {
    marginBottom: theme.spacing(4),
    fontSize: '2em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  sectionHeader2: {
    fontSize: '2em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  tabsButton: {
    letterSpacing: '1px',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    fontSize: '.8em',
  },
  button: {
    marginTop: theme.spacing(2),
  },
  policyButton: {
    marginTop: theme.spacing(),
  },
  cost: {
    display: 'inline-block',
    marginBottom: theme.spacing(2),
    fontSize: '1.5em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    float: 'right',
  },
  costPrice: {
    display: 'inline-block',
    fontSize: '1.5em',
    letterSpacing: '1px',
  },
  priceContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  popoverSection: {
    maxWidth: '100%',
    padding: theme.spacing(3),
  },
  discoverRight: {
    [theme.breakpoints.up(900)]: {
      borderLeft: '1px solid black',
      paddingLeft: '10%',
    },
    [theme.breakpoints.down(899)]: {
      paddingTop: '10%',
    },
  },
  centerText: {
    textAlign: 'center',
    paddingTop: '10%',
  },
  padTop: {
    marginTop: theme.spacing(4),
  },
  discoverHeader: {
    fontSize: '1.8rem',
    letterSpacing: '3px',
  },
});

function Template({ classes }) {
  return (
    <div className={classes.page}>

      <Helmet>
        <title>Nia Membership | A Holistic Approach to Mind Body Fitness</title>
        <meta name="description" content="Discover your Nia community and find out what a Nia membership can do for you! The pathway to holistic, mind body fitness and wellness starts here." />
        <meta name="keywords" content="mind, body, fitness" />
      </Helmet>

      <NavBar />
      <main className={classes.container}>
        <div className={classes.appBarSpacer} />
        <div className={classes.content}>
          <div className={classes.hero}>
            <img className={classes.heroImg} alt="Membership Page Hero" src={heroImg} />
          </div>
          <div className={classes.section}>
            <Grid container>
              <Grid item xs={12} sm={5}>
                <Typography color="textSecondary" className={classes.discoverHeader} variant="h1">{content.discover}</Typography>
              </Grid>
              <Grid item xs={12} sm={7}>
                <Typography className={classes.discoverRight} variant="body2">{content.description}</Typography>
              </Grid>
            </Grid>
          </div>
          <div className={classes.section}>
            <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">CHOOSE YOUR NIA MEMBERSHIP</Typography>
            <Grid container>
              <Grid item xs={12} sm={4}>
                <MembershipCard type={content.dancing} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <MembershipCard type={content.athlete} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <MembershipCard type={content.livelihood} />
              </Grid>
            </Grid>
            <Hidden smUp>
              <MobileMembershipChart inputClass={classes.centerText} inputClass2={classes.padTop} />
            </Hidden>
          </div>
          <div className={classes.section}>
            <img className={classes.stockImg} alt="Membership Page Hero" src={stockImg} />
            <Grid container>
              <Grid item xs={12} sm={4}>
                <QuoteCard quote={content.quote1} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <QuoteCard quote={content.quote2} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <QuoteCard quote={content.quote3} />
              </Grid>
            </Grid>
          </div>
          <div className={classes.divider} />
          <div className={classes.section}>
            <Hidden xsDown>
              <MembershipChart
                sectionHeader={classes.sectionHeader2}
                athlete={content.athlete}
                chart={content.chart}
                dancing={content.dancing}
                livelihood={content.livelihood}
              />
            </Hidden>
          </div>
        </div>
        <FooterSpacer />
      </main>
      <Footer />
    </div>
  );
}

Template.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Template);
